import { useEffect, useRef } from 'react';

/**
 * ScrollProgress — fine barre de progression de lecture en haut de page.
 *
 * Se branche sur l'événement `scroll` de Lenis (qui fournit `progress` 0→1)
 * quand le smooth-scroll est actif — framer-motion `useScroll` ne capte PAS
 * le scroll piloté par Lenis. Repli sur un listener natif quand Lenis est
 * absent (reduced-motion). Purement décorative (aria-hidden).
 */
export default function ScrollProgress() {
  const ref = useRef(null);

  useEffect(() => {
    const set = (p) => {
      if (ref.current) ref.current.style.transform = `scaleX(${Math.max(0, Math.min(1, p || 0))})`;
    };
    const fromWindow = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      set(max > 0 ? window.scrollY / max : 0);
    };

    const lenis = window.__lenis;
    let onLenis = null;
    if (lenis && typeof lenis.on === 'function') {
      onLenis = ({ progress }) => set(progress);
      lenis.on('scroll', onLenis);
      fromWindow(); // état initial
    } else {
      window.addEventListener('scroll', fromWindow, { passive: true });
      fromWindow();
    }
    window.addEventListener('resize', fromWindow, { passive: true });

    return () => {
      if (lenis && onLenis) lenis.off('scroll', onLenis);
      window.removeEventListener('scroll', fromWindow);
      window.removeEventListener('resize', fromWindow);
    };
  }, []);

  return (
    <div
      ref={ref}
      aria-hidden="true"
      className="fixed inset-x-0 top-0 z-[90] h-[3px] origin-left scale-x-0 bg-gradient-to-r from-bordeaux-600 via-bordeaux-500 to-tool-600"
      style={{ willChange: 'transform' }}
    />
  );
}
